export const TIME_SHEET_DOCS_SETTINGS_COMPANY_GRAPH_QUERY = Object.freeze({
  graph: {
    companyDocsSettings: {
      holidayLeave: true,
      paidLeave: true,
      nonPaidLeave: true,
      bonus: true,
      suspension: true,
      maternityLeave: true,
      pregnancyLeave: true,
      holidayLeaveEmail: true,
      paidLeaveEmail: true,
      nonPaidLeaveEmail: true,
      bonusEmail: true,
      suspensionEmail: true,
      maternityLeaveEmail: true,
      pregnancyLeaveEmail: true,
      sendRequestEmailsToEmployees: true,
      showSignatureOnDocs: true,
      hideEmployeeSignature: true,
      showMemorandumInDocs: true,
      customTemplates: true,
    },
    companyMemorandum: {
      typeOfFile: true,
      location: true,
      originalName: true,
    },
  },
});
